import React from 'react';

const Education = () => {
    return (
        <section id="education">
            <div className="container hidden">
                <h2 className="title">Education</h2>
                <div className="education-content">
                    <p>M.Sc. in Computer Science from The Chinese University of Hong Kong (CUHK), 2025-2027(expected).</p>
                    <p>B.Sc. in Computer Science with Honours (First Class) from The Chinese University of Hong Kong (CUHK), 2020-2024.</p>
                </div>
            </div>
        </section>
    );
};

export default Education;